import React, { useState, useEffect } from "react";
import "./whatisled.css";
import whatisled from "../../images/whatisled.png";
import whatisledtwo from "../../images/whatisled2.png";

function Whatisled() {
  const [ledData, setLedData] = useState({
    title1: "What is LEDs Go?",
    description1: "Leds Go is a platform for commercial video placement on LED monitors in the Dubai emirate.",
    title2: "How Does It work",
    description2: "LEDs Go allows the advertisers to place advertisement according to spot number only in a few steps and short period of time. This platform is unique and it is completely visible to the client ?",
    image1Url: "",
    image2Url: "",
  });

  // Fetch data from Strapi
  useEffect(() => {
    const fetchLedData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_STRAPI_API_URL}/api/whatisleds?populate=*`);
        const result = await response.json();
        if (result.data && result.data.length > 0) {

          const { title1, description1, title2, description2, image1, image2 } = result.data[0];

          const image1Url = image1?.url ? `${image1.url}` : 'none';
          const image2Url = image2?.url ? `${image2.url}` : 'none';

          setLedData({ title1, description1, title2, description2, image1Url, image2Url });
        }
      } catch (error) {
        console.error("Error fetching Strapi data:", error);
      }
    };

    fetchLedData();
  }, []);

  return (
      <section>
        <div className="whatIsLed">
          <div className="container">
            <div className="whatIsLedContent">
              <div className="whatIsLedContentOne">
                <div className="whatIsLedImag">
                  <img className="whatIsLedFirst" src={ledData.image1Url} alt="image" />
                  <img
                      className="whatIsLedSecond"
                      src={whatisledtwo}
                      alt="image"
                  />
                </div>
                <div className="whatIsLedText">
                  <h3>{ledData.title1}</h3>
                  <p>{ledData.description1}</p>
                </div>
              </div>
              <div className="whatIsLedContentTwo">
                <div className="whatIsLedText">
                  <h3>{ledData.title2}</h3>
                  <p>{ledData.description2}</p>
                </div>
                <div className="whatIsLedImag">
                  <img className="whatIsLedFirst" src={ledData.image2Url} alt="image" />
                  <img
                      className="whatIsLedSecond"
                      src={whatisledtwo}
                      alt="image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
}

export default Whatisled;